<template>
  <div>
    <div
      @contextmenu.prevent="$refs.pathwayViewEditMenu.open"
      :style="`${calculateBorderColor(pathwayColor)} padding: 0.075rem`"
      class="mb-1 rounded position-relative overflow-hidden drop-shadow-default"
    >
      <img class="d-none d-md-flex" style="position: absolute; right: 0; top: 0; width: 100%" :src="pathwayImage" v-if="pathwayImage" />

      <div class="rounded" style="background: #191a22">
        <div class="card-body rounded z-2 position-relative" :style="calculateBackgroundColor(pathwayColor)">
          <div class="d-flex align-items-center">
            <b-avatar
              :src="pathwayData.avatar"
              :text="avatarText(pathwayData.name)"
              size="65px"
              variant="light-info"
              class="mr-1"
              style="margin-top: 3px"
              rounded
            />
            <div class="d-flex flex-column align-items-start justify-content-center">
              <div class="d-flex align-items-center mb-25">
                <h4 class="font-weight-bolder tracking-tighter mr-50" style="font-size: 1.85rem; line-height: 2.2rem; margin-bottom: 2px">
                  {{ pathwayData.name }}
                </h4>
                <feather-icon
                  icon="EditIcon"
                  size="13"
                  class="cursor-pointer text-muted"
                  style="margin-top: 1px"
                  @click="$emit('update:edit-pathway-active', true)"
                />
              </div>

              <div class="d-flex align-items-center">
                <b-badge class="profile-badge mr-25" :variant="`${resolvePathwayStatusVariant(pathwayData.status)}`">
                  <feather-icon :icon="resolvePathwayStatusIcon(pathwayData.status)" size="12" />
                  {{ title(pathwayData.status) }}
                </b-badge>
                <b-badge class="profile-badge" :variant="`light-${resolvePathwayVisibilityVariant(pathwayData.visibility)}`">
                  <feather-icon :icon="resolvePathwayVisibilityIcon(pathwayData.visibility)" size="12" />
                  {{ title(pathwayData.visibility) }}
                </b-badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-context ref="pathwayViewEditMenu" class="mw-8">
      <li v-if="$can('roster.pathway.update')">
        <a class="d-flex align-items-center justify-content-between" @click="$emit('update:edit-pathway-active', true)">
          <span>Edit</span>
          <feather-icon icon="Edit3Icon" size="15" class="ml-50 text-muted" />
        </a>
        <a v-if="$can('roster.pathway.delete')" class="d-flex align-items-center justify-content-between" @click="archivePathway">
          <span>Archive</span>
          <feather-icon icon="TrashIcon" size="15" class="ml-50 text-muted" />
        </a>
      </li>
    </vue-context>
  </div>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol, BBadge, BLink } from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import usePathways from '../usePathways';
import { title } from '@core/utils/filter';
import useAppConfig from '@core/app-config/useAppConfig';
import VueContext from 'vue-context';
import store from '@/store';
import rosterStoreModule from '../../../../../store/roster/rosterStoreModule';
import { onUnmounted } from '@vue/composition-api';
import { hexToRGB } from '@/libs/utils/color';

const { skin } = useAppConfig();

export default {
  components: {
    BLink,
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    VueContext,
  },
  props: {
    pathwayData: {
      type: Object,
      required: true,
    },
    editPathwayActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    pathwayColor() {
      if (this.pathwayData.metadata && this.pathwayData.metadata.design && this.pathwayData.metadata.design.color) {
        return this.pathwayData.metadata.design.color;
      }
      return '#5b5b5e';
    },
    pathwayImage() {
      if (this.pathwayData.metadata && this.pathwayData.metadata.design && this.pathwayData.metadata.design.image) {
        return this.pathwayData.metadata.design.image;
      }
      return null;
    },
  },
  methods: {
    archivePathway() {
      this.$swal({
        title: 'Are you sure?',
        text: 'Are you sure you want to archive this pathway?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remove',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          store
            .dispatch('rosterStoreModule/updatePathway', {
              pathwayId: this.pathwayData.id,
              pathwayData: { status: 'archived' },
            })
            .then((response) => {
              // this.refetchData();
              this.$emit('refetch-data');
            });
        }
      });
    },
    calculateBackgroundColor(hex) {
      const rgb = hexToRGB(hex);
      return `background: linear-gradient(200deg, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.35) 0%, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.05) 93.34%)`;
    },
    calculateBorderColor(hex) {
      const rgb = hexToRGB(hex);
      return `background: linear-gradient(190deg, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.9) 0%, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.03) 100%);`;
    },
  },
  setup() {
    const { resolvePathwayStatusVariant, resolvePathwayStatusIcon, resolvePathwayVisibilityVariant, resolvePathwayVisibilityIcon } =
      usePathways();
    return {
      avatarText,
      resolvePathwayStatusVariant,
      resolvePathwayStatusIcon,
      resolvePathwayVisibilityIcon,
      resolvePathwayVisibilityVariant,
      title,
      skin,
    };
  },
};
</script>

<style></style>
